import { render, staticRenderFns } from "./HandlerPopup.vue?vue&type=template&id=6336f0a6&"
import script from "./HandlerPopup.vue?vue&type=script&lang=js&"
export * from "./HandlerPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports